import React, { useEffect } from 'react';
import { FaArrowRight, FaRegCalendarAlt } from "react-icons/fa";
import './Contact.css'
import AOS from 'aos';
import 'aos/dist/aos.css';
import { HiOutlineMail } from 'react-icons/hi';
import { PopupButton } from 'react-calendly';

const Contact = () => {

    useEffect(() => {
        AOS.init({ duration: 2000 });
    }, []);


    return (
        <div
            name="contact"
            className="w-full bg-[#070716] p-4 text-white"
        >
            <div className="flex flex-col p-4 justify-center max-w-screen-lg mx-auto h-full">
                <div className="pb-6 text-center">
                    <div className="text-center">
                        <p className='style'><span className='ml-12 text-sm'>say hello</span></p>
                        <p className="text-3xl font-bold inline">Contact</p>

                    </div>
                    <div className="text-center max-w-xs lg:max-w-3xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-8 mt-6">
                        <div className="mb-5 rounded-xl hover:border-solid border-2 hover:border-blue-700 hover:animate-pulse aos-init" data-aos="zoom-in-right">
                            <div className="px-16 py-7">
                                <h2 className="flex justify-center text-2xl text-white mb-3">
                                    <HiOutlineMail size={50} />
                                </h2>
                                <a href="mailto:shafkatsaad@gmail.com" className='text-white'>shafkatSaad@gamil.com</a>
                                <p className="text-sm text-gray-400">Email me</p>
                            </div>
                        </div>
                        <div className="mb-5 rounded-xl hover:border-solid border-2 hover:border-blue-700 hover:animate-pulse aos-init" data-aos="zoom-in-left">
                            <div className="px-20 py-7">
                                <h2 className="flex justify-center text-2xl text-white mb-4">
                                    <FaRegCalendarAlt size={45} />
                                </h2>
                                <PopupButton
                                    url="https://calendly.com/shafkatsaad/30min?back=1&month=2023-02"
                                    rootElement={document.getElementById("root")}
                                    text="Schedule a Meeting"
                                />
                                <p className="text-sm text-gray-400">Calendly</p>
                            </div>
                        </div>
                    </div>
                    <p className="pt-6 text-xl">Get in touch with me</p>
                </div>
                <div className=" flex justify-center items-center">
                    <form
                        action="https://getform.io/f/0fd20d39-a341-4c24-9ea3-68ee19853c6e"
                        method="POST"
                        className=" flex flex-col w-full md:w-1/2"
                    >
                        <input
                            type="text"
                            name="name"
                            placeholder="Your Name*"
                            className="p-2 bg-transparent border-2 rounded-md text-white focus:outline-none"
                            required
                        />
                        <input
                            type="text"
                            name="email"
                            placeholder="Your Email*"
                            className="my-4 p-2 bg-transparent border-2 rounded-md text-white focus:outline-none"
                            required
                        />
                        <textarea
                            name="message"
                            placeholder="Your Message*"
                            rows="5"
                            className="p-2 bg-transparent border-2 rounded-md text-white focus:outline-none"
                            required
                        ></textarea>

                        <button className="text-white bg-gradient-to-b from-cyan-500 to-blue-500 px-6 py-3 my-8 mx-auto flex items-center rounded-md hover:scale-110 duration-300">
                            Send
                            <FaArrowRight className='ml-1' />
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default Contact;